import { render, staticRenderFns } from "./fieldtype_number.vue?vue&type=template&id=f453ddce&scoped=true&"
import script from "./fieldtype_number.vue?vue&type=script&lang=js&"
export * from "./fieldtype_number.vue?vue&type=script&lang=js&"
import style0 from "./fieldtype_number.vue?vue&type=style&index=0&id=f453ddce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f453ddce",
  null
  
)

export default component.exports